

function Contact() {
    const name = "TE. Aymi";
    const number = "1-437-236-1976";
    const email = "blina.reno@gmail.com";

    return (
        <div className="contact-div">
            <h2 className="contact-h2">Contact Us</h2>
            <p className="contact-p">Name: {name}<br/>                Phone: {number}<br/>
                Email: <a href={`mailto:${email}`}>{email}</a><br/>
                Location: Calgary, AB, Canada<br/></p>

            
        </div>
    );
}

export default Contact;
